/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import SearchDataService from "../Services/SearchData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import DefaultArticle from "../Images/article-icon.png";
import { useTranslation } from "react-i18next";
import "../Styles/Search.css";
import Loading from "../Components/Loading";
import i18n from "../i18n";
import { LogInModel } from "./LoginModel";
import ImageModal from "../Components/ImageModal";

const SearchDataPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [Searchdata, setSearchdata] = useState<any[] | undefined | any>(undefined);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  const [len, setLen] = useState("");

  const params: any = window.history.state;

  const [refresh, setRefresh] = useState(false);

  const [load, setLoad] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(12);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Searchdata?.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber: any) => setCurrentPage(pageNumber);
  const UserIdentity = localStorage.getItem("UserId") as any;

  const [logIn, setLogIn] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const openImage = (thumb?: string) => {
    if (!thumb) return;
    try {
      let hq = thumb;
      if (thumb.indexOf("/small/") !== -1) hq = thumb.replace("/small/", "/medium/");
      else if (thumb.indexOf("/small") !== -1) hq = thumb.replace("/small", "/medium");
      setSelectedImage(hq);
    } catch (e) {
      setSelectedImage(thumb);
    }
  };

  const closeModal = () => {
    setLogIn(false);
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    {
      currentItems.map((search: any, i: number) => {
        if (search.product === "audio") {
          localStorage.setItem("type", "audios")
          navigate(`/audios/` + search.slug,
            {
              state: {
                audioId: search.id,
                audioslug: search.slug,
                index: i,
                searched: window.location.pathname,
              },
            })
        }
        if (search.product === "pravachan") {
          localStorage.setItem("type", "pravachans")
          navigate(`/pravachans/` + search?.slug,
            {
              state: {
                audioId: search.id,
                audioslug: search.slug,
                index: i,
                searched: window.location.pathname,
              },
            })
        }
        if (search.product === "article") {
          navigate(`/articles/` + search.slug,
            {
              state: {
                articleId: search.id,
                articleSlug: search.slug,
                index: i,
                searched: window.location.pathname,
              },
            })
        }
      })
    }
  };

  const state = location.state as {
    product: string,
    searchtext: string,
    author: string
  };

  useEffect(() => {
    SearchDataService.searchData(
      state?.product,
      state?.searchtext,
      state?.author,
    ).then((res) => {
      if (res.status) {
        setLen(res?.result?.length);
        setSearchdata(res?.result);
        setPagination({
          ...pagination,
          // recordsPerPage: 12,
          totalRecords: res?.result?.length,
        });
      }
    });
  }, [params, i18n.language]);

  window.onload = function pageLoad() {
    if (load) {
      window.location.reload();
      setLoad(false);
    }
  };

  return (
    <>
      <div
        className="breadcrumbs-head newcontainer"
        style={{
          width: "100%",
          marginTop: "-175px",
          background: "none",
          backgroundColor: "#ffedbc",
          height: "240px",
          borderBottom: "2px solid #fff",
          paddingTop: 0,
        }}
      >
        <div className="breadcrumbs">
          <div
            className="containers"
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(209, 21, 1)",
              top: "155px",
              fontFamily: "ChanakyaUni"
            }}
          >
            {t("Search_tr")}
            <div
              style={{
                fontSize: "19px",
                fontWeight: 600,
                color: "#2d2a29",
                marginTop: "-8px",
              }}
            >
              <Link style={{ marginRight: "4px", color: "#2d2a29" }} to="/">
                {t("Home_tr")}
              </Link>
              <span style={{ color: "#2d2a29" }}>/ {t("Search_tr")}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255, 246, 225)",
          marginTop: -"3px",
          padding: "1px 0 3% 0",
        }}
      >
        <div className="containers">
          <div className="row">
            <div
              className="col-6"
              style={{
                textAlign: "center",
                fontSize: "25px",
                fontFamily: "ChanakyaUni",
                color: "rgb(209, 21, 1)",
                display: "flex",
              }}
            >
              {t("Search_tr")} :
              <div
                style={{
                  marginLeft: "15px",
                  color: "#472d1e",
                  fontFamily: "ChanakyaUni",
                  fontSize: "28px",
                  marginTop: "-4px",
                }}
              >
                {state?.searchtext}
              </div>
            </div>
            <div className="col-6">
              <div
                className="filter1"
                style={{ marginTop: "10px", textAlign: "right" }}
              >
                <span>
                  {t("Total_Records_tr")} : {len}
                </span>
              </div>
            </div>
          </div>

          <div className="gst-page-content">
            <div
              className="listcolor"
              style={{ padding: "35px", background: "#fffaf0" }}
            >
              {currentItems &&
                currentItems !== undefined &&
                currentItems.length > 0 ? (
                <div className="row">
                  {currentItems.map((search: any, i: number) => (
                    <div
                      className="col-lg-12"
                      key={`searchbook-${search.id}`}
                      onClick={() => {
                        if (search.product === "book") {
                          navigate("/books/" + search.slug,
                            {
                              state: {
                                bookId: search.id,
                                bookSlug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "kalyan") {
                          navigate("/magazines/kalyan/" + search.slug,
                            {
                              state: {
                                kalyanId: search.id,
                                kalyanSlug: search?.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "kalyankalpataru") {
                          navigate("/magazines/kalyanakalpataru/" + search.slug,
                            {
                              state: {
                                kalpatruId: search.id,
                                kalpatruSlug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "monthlymagazine") {
                          navigate("/magazines/geetgovind/" + search.slug,
                            {
                              state: {
                                MonthId: search.id,
                                monthSlug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "vivekvani") {
                          navigate("/magazines/vivekvani/" + search.slug,
                            {
                              state: {
                                vivekId: search?.id,
                                vivekSlug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "amritvachan") {
                          navigate("/divinequotes/" + search.id,
                            {
                              state: {
                                divineId: search.id,
                                divineSlug: search?.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        // Audio / pravachan play without login; video/article still require login
                        if (search.product === "audio") {
                          localStorage.setItem("type", "audios")
                          navigate(`/audios/` + search.slug,
                            {
                              state: {
                                audioId: search.id,
                                audioslug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "pravachan") {
                          localStorage.setItem("type", "pravachans")
                          navigate(`/pravachans/` + search?.slug,
                            {
                              state: {
                                audioId: search.id,
                                audioslug: search.slug,
                                index: i,
                                searched: window.location.pathname,
                              },
                            })
                        }
                        if (search.product === "Video") {
                          if (UserIdentity) {
                            navigate(`/videos`, {
                              state: {
                                videoId: search.id,
                                Name: search.name
                              },
                            })
                          } else {
                            setLogIn(true);
                          }
                        }
                        if (search.product === "article") {
                          if (UserIdentity) {
                            navigate(`/articles/` + search.slug,
                              {
                                state: {
                                  articleId: search.id,
                                  articleSlug: search.slug,
                                  index: i,
                                  searched: window.location.pathname,
                                },
                              })
                          } else {
                            setLogIn(true);
                          }
                        }
                      }}
                    >
                      <div
                        className="row cardBody"
                        style={{
                          textAlign: "left",
                          margin: "0px 0px 25px",
                        }}
                      >
                        <div className="col-lg-1" style={{ paddingTop: "5px" }}>
                          <a style={{ cursor: "pointer" }}>
                            <img
                              src={
                                search.product === "amritvachan"
                                  ? (search?.ThumbPath || search?.thumbPath || DefaultArticle)
                                  : search.product === "book" || search.product === "kalyan" || search.product === "kalyankalpataru" || search.product === "monthlymagazine" || search.product === "vivekvani"
                                    ? `${search?.thumbPath}`
                                    : search.product === "Video"
                                      ? `https://img.youtube.com/vi/${search?.lyricsHash}/hqdefault.jpg`
                                      : search.product === "audio" || search.product === "pravachan"
                                        ? search.lyricsHash != null && search.lyricsHash !== ""
                                          ? WithLyrics
                                          : WithoutLyrics
                                        : `${DefaultArticle}`
                              }
                              onClick={(e) => {
                                if (search.product === "amritvachan") {
                                  e.stopPropagation();
                                  openImage(search?.ThumbPath || search?.thumbPath);
                                }
                              }}
                              alt={search.name}
                              style={{
                                fontSize: "15px",
                                height: "70px",
                                width: "60px",
                                cursor: search.product === "amritvachan" ? "pointer" : "default",
                              }}
                              title={search.name}
                              height="70px"
                              width="60px"
                            />
                          </a>
                        </div>
                        <div className="col-lg-11 searchData">
                          <p
                            className="searchData"
                            style={{ cursor: "pointer", fontFamily: "ChanakyaUni", padding: "10px 0 8px 0" }}
                          >
                            {search.name}
                          </p>
                          <p style={{ cursor: "pointer" }}>{search.author}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div style={{ display: Searchdata?.length <= 12 ? "none" : "block" }}>
                    <div className="button-container" style={{ display: "flex" }}>
                      <button className="page-link" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                        {'<<'}
                      </button>
                      <button className="page-link" onClick={() => setCurrentPage(prevPage => prevPage - 1)} disabled={currentPage === 1}>
                        {'<'}
                      </button>
                      {Array.from({ length: Math.ceil(Searchdata?.length / itemsPerPage) }).map((_, index) => (
                        <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>
                          {index + 1}
                        </button>
                      ))}
                      <button className="page-link" onClick={() => setCurrentPage(prevPage => prevPage + 1)} disabled={currentPage === Math.ceil(Searchdata?.length / itemsPerPage)}>
                        {'>'}
                      </button>
                      <button className="page-link" onClick={() => setCurrentPage(Math.ceil(Searchdata?.length / itemsPerPage))} disabled={currentPage === Math.ceil(Searchdata?.length / itemsPerPage)}>
                        {'>>'}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ebooks-category resultnotfound">
                  {Searchdata?.length === 0 ? (
                    <label>{t("result_not_found_tr")}</label>
                  ) : (
                    <Loading />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LogInModel
        opens={logIn}
        onCloses={closeModal}
        onLoginStateChange={handleLoginStateChange}
      />
      <ImageModal imageUrl={selectedImage} onClose={() => setSelectedImage(null)} />
    </>
  );
};
export default SearchDataPage;
